import { CategoryDescription } from './category-description';
import { useGetCategoryDescription } from './use-get-category-desciption';

export const LazyLoadSection = ({ categoryData }: { categoryData: any }) => {
  const { categoryDescription, mobileCategoryDescriptionTitle } = useGetCategoryDescription({
    categoryData,
  });

  return (
    <div className='container mx-auto px-[16px] pb-[20px] lg_px-0 lg_pb-[60px]'>
      <CategoryDescription
        categoryDescription={categoryDescription}
        mobileCategoryDescriptionTitle={mobileCategoryDescriptionTitle || ''}
      />
      {/* <CategoryFaq categoryId={uid} /> */}
    </div>
  );
};
